import { HeroImageContainer, HeroSectionOne, HeroSectionTwo, ImageSection } from './HeroImage.style'
import ImageSectionOne from '../../assets/HeroImage/section-one.png'
import ImageSectionTwo from '../../assets/HeroImage/section-two.png'
import Background from '../../assets/HeroImage/Background.png'

const HeroImage = () => {
  return(
    <HeroImageContainer>
      <HeroSectionOne>
        <ImageSection>
          <img src={Background} alt='Background' />
        </ImageSection>
        <h1>Eupha</h1>
        <br />
        <p>Somos una familia que trabaja con la representación exclusiva de diversos laboratorios de renombre a nivel mundial.</p>
        <img src={ImageSectionOne} alt='ImageSectionOne' />
      </HeroSectionOne>
      <HeroSectionTwo>
        <h1>Pharma</h1>
        <p>Enfoque de salud que combina lo medicina convencional con terapias complementarias y alternativas, buscando tratar a la persona de manera holística.</p>
        <img src={ImageSectionTwo} alt='ImageSectionTwo' />
      </HeroSectionTwo>
    </HeroImageContainer>
  )
}

export default HeroImage